import classnames from "classnames";
import {FaExclamationTriangle} from "react-icons/fa";

import {Alert} from "@/components/alert/Alert.tsx";
import {SLAReport, SLAReportResponseTime} from "@/lib/queries/reports.ts";
import {SLAReportResponseTimeItem} from "@/pages/reports/sla/details/responsetime/SLAReportResponseTimeItem.tsx";

interface SLAReportOverviewResponseTimeProps {
  responseTime: SLAReportResponseTime[];
  report: SLAReport;
  dailyResponseData: boolean;
  groupOnly: boolean;
}

export const SLAReportOverviewResponseTime = ({
  dailyResponseData,
  responseTime,
  report,
  groupOnly,
}: SLAReportOverviewResponseTimeProps) => {
  const hasResponseTime = responseTime.length > 0;
  return (
    <div className="container">
      {dailyResponseData && (
        <div className="row">
          <div className="col-12">
            <Alert icon={FaExclamationTriangle} variant="maintenance" className="mb-4 align-items-center">
              This report is using daily response time datapoints because the date range starts more than 90 days ago
              and/or more than 100 Checks have been selected.
              <br />
              This may result in reduced accuracy in response time SLA calculations.
            </Alert>
          </div>
        </div>
      )}
      {!groupOnly && !hasResponseTime && (
        <div className="row mt-2">
          {report.filter_response_time_sla_violations && (
            <span>No Checks were recorded below their Target SLA in the selected period.</span>
          )}
          {!report.filter_response_time_sla_violations && <span>No Checks match the report settings.</span>}
        </div>
      )}
      {responseTime.map((item, idx) => (
        <SLAReportResponseTimeItem
          key={`response-item-${idx}`}
          report={report}
          item={item}
          className={classnames({
            "mt-4": idx == 0,
            "mt-3": idx > 0,
          })}
        />
      ))}
      {groupOnly && !hasResponseTime && (
        <div className="row mt-2">
          <span>
            Response time data is available for a maximum range of 31 days. Select a range of 31 days or fewer to view
            response time data.
          </span>
        </div>
      )}
    </div>
  );
};
